import React from "react";
import { graphql } from "gatsby";
import PageLayout from "../components/PageLayout";
import Section from "../components/Section";
import Container from "../components/Container";
import { ContentAndQuote } from "../components/ContentAndQuote";
import PageHeader from "../components/PageHeader";
import { RelatedProducts } from "../components/RelatedProducts";
import { RelatedArticles } from "../components/RelatedArticles";
import { SocialSharer } from "../components/SocialSharer";

export default function KnowledgeBaseArticle({ location, data: { page, site } }) {
  const url = location.href ? location.href : "";
  return (
    <PageLayout
      seo={page}
      breadcrumbs={page.seo.breadcrumbs}
      disableSubscribeToNewsletter={page.pageSettings?.disableGlobalSubscribeToNewsletterComponent}
      useSsss={page.pageSettings?.useSsss}
    >
      <Section>
        <Container>
          <PageHeader title={page.title} />
          <SocialSharer pageUrl={url} />
          <ContentAndQuote content={page.content} source={page.uri} />
        </Container>
      </Section>
      {page.knowldgeBaseData !== null && (
        <>
          {page.knowldgeBaseData.relatedArticles &&
          page.knowldgeBaseData.relatedArticles.length > 0 ? (
            <RelatedArticles articles={page.knowldgeBaseData.relatedArticles} />
          ) : (
            ""
          )}
          {page.knowldgeBaseData.relatedProducts &&
          page.knowldgeBaseData.relatedProducts.length > 0 ? (
            <RelatedProducts products={page.knowldgeBaseData.relatedProducts} />
          ) : (
            ""
          )}
        </>
      )}
    </PageLayout>
  );
}

export const query = graphql`
  query($id: String!) {
    page: wpKnowledgeBaseArticle(id: { eq: $id }) {
      pageSettings {
        disableGlobalSubscribeToNewsletterComponent
        useSsss
      }
      nodeType
      title
      content
      uri
      knowldgeBaseData {
        relatedArticles {
          article {
            ... on WpKnowledgeBaseArticle {
              id
              uri
              title
              featuredImage {
                node {
                  mediaItemUrl
                }
              }
            }
          }
        }
        relatedProducts {
          relatedProduct {
            ... on WpProduct {
              id
              title
              uri
              rolloverImage {
                rolloverImage {
                  mediaItemUrl
                }
              }
              productCategories {
                nodes {
                  id
                  name
                }
              }
              productData {
                specification {
                  depth
                  height
                  heightWithFence
                  weight
                  width
                  filledWeight
                  crashtested
                  windtunneltested
                }
                productGallery {
                  mediaItemUrl
                }
                productMeta {
                  stackStatus
                  hirePrice {
                    price
                    info
                    priceOnApplication
                  }
                  buyPrice {
                    price
                    info
                    priceOnApplication
                  }
                }
              }
            }
          }
        }
      }
      seo {
        ...SeoFields
      }
    }
  }
`;
